// Local facts for the smaller Capital Region towns that previously had only a
// generic pressure-washing hub page. Used to build the house-washing and
// roof-washing city clusters for those towns.
export type TownFact = {
  city: string;
  slug: string;
  /** Housing-stock and exposure detail used in the intro. */
  local: string;
  /** Roof-specific exposure detail. */
  roof: string;
  hoods: string[];
};

export const TOWN_FACTS: TownFact[] = [
  {
    city: "Altamont",
    slug: "altamont",
    local:
      "Altamont sits right at the foot of the Helderberg escarpment, so village homes get wind-driven rain off the hill and long damp shade under old maples along Maple Ave and Grand St. Painted clapboard and older wood trim on the village Victorians need a soft wash, not pressure.",
    roof:
      "Roofs below the escarpment stay wet longer than roofs a few miles out on the flats, and the tree cover through the village center keeps north slopes from ever fully drying between rains.",
    hoods: ["Village Center", "Maple Ave", "Grand St", "Fairgrounds area", "Route 156 corridor", "Settles Hill", "Warner Hill", "Guilderland Center border"],
  },
  {
    city: "Bethlehem",
    slug: "bethlehem",
    local:
      "Bethlehem covers everything from Delmar and Elsmere Colonials to farmhouses out toward Feura Bush and riverfront homes at Cedar Hill. The common thread is mature canopy and Hudson Valley humidity, which puts green algae on north-facing siding within a couple of seasons.",
    roof:
      "Bethlehem's oaks and maples drop debris into valleys all fall, and the shaded slopes through Elsmere, Selkirk, and Cedar Hill hold enough moisture to grow moss on top of the usual black streaking.",
    hoods: ["Delmar", "Elsmere", "Selkirk", "Glenmont", "South Bethlehem", "Beckers Corners", "Cedar Hill", "Feura Bush"],
  },
  {
    city: "East Greenbush",
    slug: "east-greenbush",
    local:
      "East Greenbush neighborhoods like Hampton Manor, Bell Top, and Clinton Heights are heavy on vinyl and aluminum siding from the 60s through the 90s — surfaces that chalk, hold road film off Routes 4 and 9&20, and streak under the gutters.",
    roof:
      "The ridge neighborhoods above the Hudson catch weather from both directions, and the older asphalt roofs through Columbia Heights and Defreestville show algae streaking earlier than newer builds.",
    hoods: ["Columbia Heights", "Bell Top", "Hampton Manor", "Clinton Heights", "Defreestville", "Route 4 corridor", "Route 151 corridor", "Snyders Corners"],
  },
  {
    city: "Glenmont",
    slug: "glenmont",
    local:
      "Glenmont homes sit close to the river along River Rd and the Hudson bluffs, where morning fog lingers well past sunrise. That extra hour or two of damp is exactly what mildew needs, and it shows up first on shaded siding and around gutter lines.",
    roof:
      "River fog rolling up over Henry Hudson Park and the bluffs keeps Glenmont rooflines damp into the morning, which is why algae streaks and moss show up here faster than a few miles inland.",
    hoods: ["River Rd", "Hudson Bluffs", "Henry Hudson Park area", "Feura Bush Rd corridor", "Glenmont Rd", "Wemple Rd area", "Cedar Hill border", "Selkirk border"],
  },
  {
    city: "Halfmoon",
    slug: "halfmoon",
    local:
      "Halfmoon is mostly newer construction — vinyl and Hardie siding through Halfmoon Crossing, Grooms Rd, and the Route 9 corridor — plus older riverfront homes down toward Crescent and Vischer Ferry that take the brunt of the Mohawk humidity.",
    roof:
      "The Mohawk river corridor through Crescent and Vischer Ferry keeps humidity high, and newer Halfmoon subdivisions with young landscaping still get streaking on the north slopes within about six years.",
    hoods: ["Crescent", "Vischer Ferry", "Route 9 corridor", "Route 236 corridor", "Grooms Rd area", "Halfmoon Crossing", "Waterford border", "Clifton Park border"],
  },
  {
    city: "Loudonville",
    slug: "loudonville",
    local:
      "Loudonville has some of the area's most established homes — painted brick, cedar shake, and stucco under heavy old-growth canopy along Osborne Rd, Whitehall Rd, and Loudon Heights. These are exactly the surfaces high pressure ruins, so everything here gets soft washed.",
    roof:
      "Loudonville's dense mature canopy shades whole roof planes for most of the day, and cedar and architectural shingle roofs under those trees grow moss and lichen along with the usual algae streaking.",
    hoods: ["Loudonville Rd corridor", "Northern Blvd", "Osborne Rd", "Whitehall Rd", "Loudon Heights", "Kenwood", "Newtonville border", "Colonie border"],
  },
  {
    city: "Menands",
    slug: "menands",
    local:
      "Menands homes along the Broadway corridor and Van Rensselaer Blvd take steady traffic film off Route 32 and 378, and the riverfront section adds humidity on top of it. The result is a gray road-grime layer over the mildew rather than one or the other.",
    roof:
      "Between the Hudson right below and the traffic corridors running through it, Menands rooflines pick up both organic growth and a fine road-grime film that dulls shingles years before they wear out.",
    hoods: ["Broadway corridor", "Route 378 area", "Riverfront section", "Wards Lane", "Van Rensselaer Blvd", "Menands Rd", "Colonie border", "Albany border"],
  },
  {
    city: "Ravena",
    slug: "ravena",
    local:
      "Ravena sits on the Route 9W corridor south of Albany with a mix of older village homes on Main St and newer builds out toward Aquetuck. Cement-plant dust, road film off 9W, and river humidity all settle into siding here.",
    roof:
      "Village roofs in Ravena see plant and road dust along with the standard Capital Region algae, and the older, lower-pitch roofs through the village center hold that debris instead of shedding it.",
    hoods: ["Village Center", "Route 9W corridor", "Hudson riverfront", "Main St", "Aquetuck", "New Scotland Rd area", "Coeymans border", "Selkirk border"],
  },
];
